(function () {
  document.querySelectorAll('[data-story-hero-lola]').forEach(function (section) {
    initStory(section);
  });

  function initStory(section) {
    var details = Array.prototype.slice.call(section.querySelectorAll('[data-story-hero-lola-detail]'));
    var bgPhotos = Array.prototype.slice.call(section.querySelectorAll('[data-story-hero-lola-bg]'));
    var bottles = Array.prototype.slice.call(section.querySelectorAll('[data-story-hero-lola-bottle]'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-story-hero-lola-dot]'));
    var prevBtn = section.querySelector('[data-story-hero-lola-prev]');
    var nextBtn = section.querySelector('[data-story-hero-lola-next]');

    var total = details.length;
    if (!total) return;

    var activeIndex = 0;

    // Autoplay fires on every video as soon as it loads, regardless of
    // which flavor is active — pause anything that isn't the first one.
    bgPhotos.forEach(function (el) {
      var video = el.querySelector('video');
      if (video && !el.classList.contains('is-active')) {
        video.pause();
      }
    });

    // All three groups (text, background photo, bottle) are switched
    // together from a single index — this is what keeps the mood photo
    // and bottle in sync with whichever flavor's copy is showing.
    function goTo(index) {
      var nextIndex = ((index % total) + total) % total;
      if (nextIndex === activeIndex) return;

      [details, bgPhotos, bottles, dots].forEach(function (group) {
        group.forEach(function (el) {
          var isActive = parseInt(el.getAttribute('data-index'), 10) === nextIndex;
          el.classList.toggle('is-active', isActive);
        });
      });

      // Only the active flavor's background video should actually play —
      // keeps inactive videos paused so they don't all run at once behind
      // the crossfade.
      bgPhotos.forEach(function (el) {
        var video = el.querySelector('video');
        if (!video) return;
        if (el.classList.contains('is-active')) {
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });

      activeIndex = nextIndex;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(activeIndex - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(activeIndex + 1);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-index'), 10);
        goTo(index);
      });
    });

    // Swipe support (mobile): the mood photo is the visible touch
    // target once the layout reflows to mobile (see CSS) — same
    // mouse-drag/touch-swipe unification via Pointer Events used
    // elsewhere in the project (flavors-lola, product-showcase-lola).
    var swipeZone = section.querySelector('.story-hero-lola__bg');
    if (swipeZone) {
      var isDragging = false;
      var dragStartX = 0;

      swipeZone.addEventListener('pointerdown', function (event) {
        isDragging = true;
        dragStartX = event.clientX;
        swipeZone.setPointerCapture(event.pointerId);
      });

      swipeZone.addEventListener('pointerup', function (event) {
        if (!isDragging) return;
        isDragging = false;

        var delta = event.clientX - dragStartX;
        var threshold = 40;

        if (delta > threshold) {
          goTo(activeIndex - 1);
        } else if (delta < -threshold) {
          goTo(activeIndex + 1);
        }
      });

      swipeZone.addEventListener('pointercancel', function () {
        isDragging = false;
      });
    }
  }
})();
